/**
 * @param {string} html
 * @param {string} classList
 */
function makeMessageElement(html, classList = '') {
  const $el = document.createElement('div');

  $el.setAttribute('class', classList);
  $el.classList.add('tn-focus-outline');

  $el.innerHTML = html;

  return $el;
}

class Messenger {
  /**
   * @param {Element} $messageContainer
   */
  constructor($messageContainer) {
    this.$messageContainer = $messageContainer;
  }

  /**
   * @param {string} message
   * @param {boolean} focus
   */
  addSuccessMessage(message, focus) {
    return this.addMessage(message, 'alert alert-success', focus);
  }

  /**
   * @param {string} message
   * @param {boolean} focus
   */
  addInfoMessage(message, focus) {
    return this.addMessage(message, 'alert alert-info', focus);
  }

  /**
   * @param {string} message
   * @param {boolean} focus
   */
  addErrorMessage(message, focus) {
    return this.addMessage(message, 'alert alert-danger', focus);
  }

  /**
   * @param {string} message
   * @param {boolean} focus
   */
  addWarningMessage(message, focus) {
    return this.addMessage(message, 'alert alert-warning', focus);
  }

  /**
   * @param {string} message
   * @param {string} classList
   * @param {boolean} focus
  */
  addMessage(message, classList = 'alert', focus = false) {
    const $el = makeMessageElement(message, classList);

    this.$messageContainer.appendChild($el);

    if (focus) {
      $el.setAttribute('tabindex', -1);
      $el.focus();
    }

    return $el;
  }

  clearMessages() {
    this.$messageContainer.innerHTML = '';
  }
}

export default Messenger;
